module.exports = __webpack_public_path__ + "static/media/2020-04-14_Summary.c4481145.jpg";